var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTasteFat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TasteFat",
    "data-name": "TasteFat",
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 112,
    viewBox: "0 0 109 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-0.135 0.024)",
    opacity: 0.069
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Icon.BG",
    cx: 54.5,
    cy: 56,
    rx: 54.5,
    ry: 56,
    transform: "translate(0.135 -0.024)",
    fill: "#c58c3c"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12627",
    "data-name": "Path 12627",
    d: "M688.5,379.739a3.725,3.725,0,0,1-2.087-1.727c-.642-1.626,1.673-3.45,2.765-4.2l1.781-1.661c-.438-1.3-1.572-4.656-1.943-5.591-.552-1.392.539-4.013.936-4.882a.381.381,0,0,0-.084.006c-14.677.792-37.156,2.232-41.6,3.077.1,4.751.72,22.352,1.536,30.235a19.634,19.634,0,0,0,.57,3.575c2.435,1.349,21.088,1.343,38.625.557l1.835-7.42.252-1.014v-4.925A21.776,21.776,0,0,0,690,380.783a3.334,3.334,0,0,0-1.5-1.044m-9.806-8.194c1.872,0,3.455,1.763,3.455,2.874,0,1.127-1.421,1.919-3.455,1.919s-3.467-.792-3.467-1.919c0-1.11,1.584-2.874,3.467-2.874M659.644,393.4a5.131,5.131,0,0,1-2-.391,2.556,2.556,0,0,1-1.812-2.219c0-1.817,3.149-2.6,4.762-2.6,1.686,0,2.67.774,2.831,2.183a3.217,3.217,0,0,1,.036.42c0,1.464-1.679,2.61-3.814,2.61m1.889-15.094c-3.251,0-5.7-1.457-5.7-3.383a4.566,4.566,0,0,1,4.762-4.337c3.047,0,6.652,2.352,6.652,4.337,0,1.926-2.453,3.383-5.709,3.383m12.426,10.8c-2.429,0-4.427-.756-5.361-1.9a2.333,2.333,0,0,1-.582-1.505c0-2.172,4.349-3.21,7.119-3.371.252-.012.5-.025.72-.025,2.8,0,4.049,1.05,4.049,3.4,0,1.938-2.555,3.4-5.944,3.4m10.3,6.035c-2.141,0-3.814-1.146-3.814-2.6,0-1.818,3.149-2.6,4.756-2.6,1.853,0,2.873.923,2.873,2.6,0,1.457-1.68,2.6-3.815,2.6",
    transform: "translate(-616.352 -324.643)",
    fill: "#fcc97a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasteFat);
export default __webpack_public_path__ + "static/media/TasteFat.a6edefc249e3ecb0097e2706d9ba6825.svg";
export { ForwardRef as ReactComponent };